export class NewUserModel {
  public usename: string;
  public password: string;
  public editPermissions: number;
  public visibilityPermissions: number;

}
